import { lazy, Suspense } from 'react'
import { useLevelUpCelebration } from '@/hooks/useMissions'

const LevelUpDialog = lazy(() => import('@/components/nextSteps/MissionsBoard').then(m => ({ default: m.LevelUpDialog })))

export function MissionCelebration() {
  const { celebration, dismiss } = useLevelUpCelebration()
  if (!celebration) return null
  return (
    <Suspense fallback={null}>
      <LevelUpDialog celebration={celebration} onClose={dismiss} />
    </Suspense>
  )
}
